// extracted by mini-css-extract-plugin
export default {"titleContainer":"top-level-styles_titleContainer__vafUm","titleText":"top-level-styles_titleText__181WL"};